import { Component, Output, EventEmitter, signal, type OnInit } from '@angular/core';
import { BaseButtonComponent } from '../base-button';
import { Checkout } from 'src/app/state/user/checkouts/models/checkout';

@Component({
  selector: 'app-renew-checkout-button',
  templateUrl: './renew-checkout-button.component.html',
  styleUrls: ['./renew-checkout-button.component.scss', '../base-button.scss'],
})
export class RenewCheckoutButtonComponent extends BaseButtonComponent implements OnInit {
  readonly checkout = signal<Checkout>(null);

  @Output()
  renewed = new EventEmitter<Checkout>();

  ngOnInit(): void {
    this.checkout.set(this.checkoutsFacade.getCheckoutByRecordId(this.record.id, this.issueDate, this.rhId));
  }

  doRenew() {
    this.doAction(() => {
      this.checkoutsFacade.postRenewCheckout(this.checkout()).subscribe({
        next: () => {
          this.renewed.emit(this.checkout());
        },
        error: (_err) => {
          this.waiting = false;
          throw _err;
        },
      });

    });
  }
}
